module.exports = __webpack_public_path__ + "static/media/telethon-logo-horizontal.e05fe8cc.svg";